import { AgendamentoListPage } from '$pages/agendamento/agendamento-list/agendamento-list';
import { AtendimentoListPage } from '$pages/atendimento/atendimento-list/atendimento-list';
import { DenunciaFormPage } from '$pages/denuncia/denuncia-form/denuncia-form';
import { DenunciaListPage } from '$pages/denuncia/denuncia-list/denuncia-list';
import { DuvidasListPage } from '$pages/duvidas-list/duvidas-list';
import { Injectable } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { App, Events } from 'ionic-angular';

@Injectable()
export class ItemProvider {

  constructor(private app: App, private inApp: InAppBrowser, private events: Events) {
  }

  public getItems(settings: any): Array<any> {
    const nav = this.app.getActiveNav();

    return [
      {
        title: 'Denunciar',
        description: 'Aponte uma situação que esteja ocorrendo com você, ou que tenha ocorrido.',
        icon: 'add-circle',
        hideMenu: true,
        hideHome: true,
        showToolbar: true,
        onAction: () => nav.push(DenunciaFormPage)
      },
      {
        title: 'Minhas Denúnicas',
        description: 'Lista suas denúncias e permite que você aponte uma situação que esteja ocorrendo ou que tenha ocorrido com você.',
        icon: 'megaphone',
        onAction: () => nav.push(DenunciaListPage, { load: true })
      },
      {
        title: 'Meus Agendamentos',
        description: 'Permite que você realize um agendamento para atendimento em nossa unidade.',
        icon: 'calendar',
        onAction: () => nav.push(AgendamentoListPage)
      },
      {
        title: 'Meus Atendimentos e Processos',
        description: 'Lista seus atedimentos e/ou processos realizados pelo PROCON FSA.',
        icon: 'list',
        onAction: () => nav.push(AtendimentoListPage, { load: true })
      },
      {
        title: 'Código de Defesa do Consumidor',
        description: 'Abre o código de defesa do consumidor online.',
        icon: 'book',
        hideMenu: true,
        onAction: () => this.inApp.create(settings.urlCodigoDefesa, '_blank').show()
      },
      {
        title: 'Dúvidas Frequentes',
        description: 'Lista as dúvidas e repostas mas procuradas pelos consumidores.',
        icon: 'help-circle',
        onAction: () => nav.push(DuvidasListPage)
      },
      {
        title: 'Sair',
        icon: 'exit',
        hideHome: true,
        showToolbar: true,
        onAction: () => this.events.publish('menu:logout')
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/providers/item.ts